import { useOrganizationFeatures } from '@hooks/useOrganizationFeatures';

// FAQ, website import and unanswered questions; the backend answers 403 without it
export const useKnowledgeBaseProAccess = () => {
  const { hasFeature, isLoading } = useOrganizationFeatures();
  return { hasProAccess: hasFeature('premium_knowledge_base'), isLoading };
};
